import auth from '~/modules/auth/auth'

export default function ({ redirect }) {
  if (auth.isAuthenticated()) {
    return redirect('/documents')
  }
}
